/* Ayudate · Catálogo de cursos del Tecnológico de Costa Rica
   ─────────────────────────────────────────────────────────────────────────
   La lista de abajo es la de los cursos que se piden para tutoría en el TEC,
   no el catálogo completo de la universidad. Antes este archivo era una
   extracción de los planes de estudio publicados en tec.ac.cr —veinticuatro
   áreas y unos setecientos cursos, la mayoría sin demanda—; hoy es la lista
   pedida, curso por curso.

   Alcance y criterios:

   · Un área por CARRERA, no por escuela ni por sigla. Es el cambio grande
     frente a la versión anterior, que partía por escuela: Electromecánica
     vuelve a ser una sola área (antes iba partida en Mecánica y
     Electricidad) y Computación se abre en dos, Ingeniería en Computación
     (siglas IC, CA) e Ingeniería en Computadores (siglas CE), que son dos
     carreras distintas con dos "Introducción a la Programación" distintas.
   · Solo cursos de GRADO tutorables. Fuera quedan los laboratorios (la
     tutoría es de la teoría), los proyectos, las prácticas y los trabajos
     finales de graduación.
   · Las cuatro áreas de servicio —Matemática, Física, Química y Biología,
     Computación— no viven acá sino escritas a mano en datos/areas.js, con su
     color histórico. Son las de más tránsito y las comparte media
     universidad; ver la nota que abre ese archivo.

   Los códigos van SIN guion (MA1102, MI3115), que es como los escribe el TEC
   y lo que los mantiene separados de los de la UCR, que van con guion
   (ver datos/cursosUCR.js).

   · Administración de Tecnologías de Información entra SIN CÓDIGO: la lista
     pedida no trae las siglas de esa carrera. Los cursos se identifican por
     el nombre, que es lo que areas.js ya hace con los idiomas y con las
     materias de colegio (ver CURSO y `sinCodigo` allá), y hay que ponerles
     la sigla cuando aparezca. Tres de esos nombres —Introducción a la
     Programación, Programación Orientada a Objetos y Estructuras de Datos—
     se repiten con cursos de Ingeniería en Computación: son cursos
     distintos de carreras distintas, y como uno va por código y el otro por
     nombre no se pisan en el catálogo.

   `grupo` es el encabezado bajo el que cae cada área en los <select> del
   panel del tutor; el buscador público no lo usa.                          */

const C = "#14B8A6";   // el turquesa del TEC; ver la nota de color en datos/areas.js

export const AREAS_TEC = [
  {
    id: "tec-computadores", nombre: "Ingeniería en Computadores",
    grupo: "Computación y TI", color: C,
    cursos: [
      { cod: "CE1101", nom: "Introducción a la Programación" },
      { cod: "CE1103", nom: "Algoritmos y Estructuras de Datos I" },
      { cod: "CE1107", nom: "Fundamentos de Arquitectura de Computadores" },
      { cod: "CE1109", nom: "Circuitos Analógicos" },
      { cod: "CE1110", nom: "Análisis de Señales Mixtas" },
      { cod: "CE1111", nom: "Análisis Numérico para la Ingeniería" },
      { cod: "CE2103", nom: "Algoritmos y Estructuras de Datos II" },
      { cod: "CE4301", nom: "Arquitectura de Computadores I" },
    ],
  },
  {
    id: "tec-ati", nombre: "Administración de Tecnologías de Información",
    grupo: "Computación y TI", color: C,
    cursos: [
      { nom: "Introducción a la Programación" },
      { nom: "Programación Orientada a Objetos" },
      { nom: "Estructuras de Datos" },
      { nom: "Análisis y Diseño de Sistemas" },
      { nom: "Bases de Datos I" },
      { nom: "Bases de Datos II" },
      { nom: "Redes de Computadoras" },
      { nom: "Investigación de Operaciones" },
    ],
  },
  {
    id: "tec-electromecanica", nombre: "Ingeniería Electromecánica",
    grupo: "Ingeniería", color: C,
    cursos: [
      { cod: "MI2101", nom: "Dibujo Técnico" },
      { cod: "MI2106", nom: "Estática" },
      { cod: "MI2109", nom: "Estática" },
      { cod: "MI2205", nom: "Electricidad I" },
      { cod: "MI2207", nom: "Electricidad II" },
      { cod: "MI3108", nom: "Mecánica de Fluidos" },
      { cod: "MI3115", nom: "Resistencia de Materiales" },
      { cod: "MI3117", nom: "Dinámica" },
      { cod: "MI3130", nom: "Termodinámica" },
      { cod: "MI3209", nom: "Electricidad III" },
      { cod: "MI3210", nom: "Máquinas Eléctricas" },
      { cod: "MI4136", nom: "Elementos de Máquinas" },
      { cod: "MI4510", nom: "Electrotecnia" },
      { cod: "MI5215", nom: "Análisis de Sistemas Eléctricos de Potencia" },
    ],
  },
  {
    id: "tec-electronica", nombre: "Ingeniería Electrónica",
    grupo: "Ingeniería", color: C,
    cursos: [
      { cod: "EL2113", nom: "Circuitos Eléctricos en Corriente Continua" },
      { cod: "EL2114", nom: "Circuitos Eléctricos en Corriente Alterna" },
      { cod: "EL2207", nom: "Elementos Activos" },
      { cod: "EL3307", nom: "Diseño Lógico" },
      { cod: "EL3310", nom: "Diseño de Sistemas Digitales" },
      { cod: "EL4201", nom: "Procesamiento Electrónico de Potencia" },
      { cod: "EL4314", nom: "Arquitectura de Computadoras I" },
      { cod: "EL4513", nom: "Teoría Electromagnética I" },
      { cod: "EL4514", nom: "Teoría Electromagnética II" },
      { cod: "EL4703", nom: "Señales y Sistemas" },
    ],
  },
  {
    id: "tec-mecatronica", nombre: "Ingeniería Mecatrónica",
    grupo: "Ingeniería", color: C,
    cursos: [
      { cod: "MT2001", nom: "Circuitos Eléctricos en CC y CA" },
      { cod: "MT3001", nom: "Electrónica Analógica" },
      { cod: "MT3003", nom: "Máquinas Eléctricas para Mecatrónica" },
      { cod: "MT4001", nom: "Electrónica Digital" },
      { cod: "MT5002", nom: "Modelos de Sistemas para Mecatrónica" },
      { cod: "MT5003", nom: "Electrónica de Potencia Aplicada" },
      { cod: "MT7001", nom: "Análisis y Simulación de Sistemas" },
      { cod: "MT7003", nom: "Microprocesadores y Microcontroladores" },
    ],
  },
  {
    id: "tec-materiales", nombre: "Ingeniería en Materiales",
    grupo: "Ingeniería", color: C,
    cursos: [
      { cod: "CM2103", nom: "Termodinámica" },
      { cod: "CM3103", nom: "Termodinámica de Materiales" },
      { cod: "CM3601", nom: "Mecánica de Fluidos" },
      { cod: "CM3603", nom: "Mecánica de Materiales Avanzada" },
      { cod: "CM4108", nom: "Transferencia de Calor" },
      { cod: "CM4701", nom: "Transferencia de Calor y Masa" },
    ],
  },
  {
    id: "tec-ing-fisica", nombre: "Ingeniería Física",
    grupo: "Ingeniería", color: C,
    cursos: [
      { cod: "IF3501", nom: "Termodinámica I" },
      { cod: "IF3602", nom: "Métodos Matemáticos de Física e Ingeniería I" },
      { cod: "IF4701", nom: "Métodos Matemáticos de Física e Ingeniería II" },
      { cod: "IF4702", nom: "Física Computacional I" },
      { cod: "IF4801", nom: "Mecánica Cuántica para Ingeniería" },
      { cod: "IF4804", nom: "Física Computacional II" },
    ],
  },
  {
    id: "tec-admin", nombre: "Administración de Empresas",
    grupo: "Administración", color: C,
    cursos: [
      { cod: "AE1122", nom: "Contabilidad I" },
      { cod: "AE1123", nom: "Contabilidad II" },
      { cod: "AE2124", nom: "Contabilidad III" },
      { cod: "AE2126", nom: "Contabilidad de Costos I" },
      { cod: "AE2308", nom: "Microeconomía" },
      { cod: "AE2311", nom: "Macroeconomía" },
      { cod: "AE2703", nom: "Computación para Administración" },
      { cod: "AE2705", nom: "Análisis y Gestión de Datos Empresariales" },
      { cod: "AE3103", nom: "Contabilidad General" },
      { cod: "AE3127", nom: "Administración Financiera I" },
      { cod: "AE3128", nom: "Administración Financiera II" },
      { cod: "AE3415", nom: "Investigación de Mercados" },
      { cod: "AE4121", nom: "Ingeniería Económica" },
      { cod: "AE4128", nom: "Auditoría I" },
      { cod: "AE4312", nom: "Macroeconomía" },
      { cod: "AE5111", nom: "Contabilidad y Finanzas" },
      { cod: "AE5113", nom: "Contabilidad Financiera" },
      { cod: "AE5121", nom: "Ingeniería Económica" },
      { cod: "AE5122", nom: "Ingeniería Financiera" },
    ],
  },
];

export const AREAS_TEC_IDS = AREAS_TEC.map((a) => a.id);
